import { render } from "./ChangeSection.vue?vue&type=template&id=2cce5d39&scoped=true"
import script from "./ChangeSection.vue?vue&type=script&lang=js"
export * from "./ChangeSection.vue?vue&type=script&lang=js"

import "./ChangeSection.vue?vue&type=style&index=0&id=2cce5d39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cce5d39"]])

export default __exports__